import type { ReactNode } from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { Badge } from "@/components/ui/badge"
import { cn } from "@/lib/utils"

const chipVariants = cva(
  "gap-1 border-0 px-2 py-1 text-[10px] font-normal leading-none uppercase shadow-none hover:bg-transparent",
  {
    variants: {
      variant: {
        comingSoon:
          "bg-white/10 text-white font-light antialiased [font-synthesis:none]",
        count: "bg-primary text-primary-foreground hover:bg-primary",
        bonus: "bg-success-460 text-success-450",
        verify: "bg-warning-460 text-warning-470/80",
        live: "bg-transparent px-0 text-success-400/70"
      }
    },
    defaultVariants: {
      variant: "comingSoon"
    }
  }
)

export type ChipVariant = NonNullable<
  VariantProps<typeof chipVariants>["variant"]
>

export type ChipProps = {
  variant?: ChipVariant
  children: ReactNode
  className?: string
}

export function Chip({
  variant = "comingSoon",
  className,
  children
}: ChipProps) {
  return (
    <Badge
      variant="outline"
      className={cn(chipVariants({ variant }), className)}
    >
      {variant === "live" ? (
        <span
          className="size-1.5 shrink-0 rounded-full bg-success-400 ring-2 ring-success-550"
          aria-hidden
        />
      ) : null}
      {children}
    </Badge>
  )
}

export { chipVariants }
